/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const house_2 = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.867 12.75v1.317c0 .508.425.933.933.933h1.8a1 1 0 0 0 1-1v-2.267c0-.508.425-.933.933-.933h.934c.508 0 .933.425.933.933V14a1 1 0 0 0 1 1h1.8a.943.943 0 0 0 .933-.933V12.75m0-3.817-2.329-2.329L8.66 4.46a.933.933 0 0 0-1.32 0L1 10.8m14 0-1.867-1.867M11.187 1l-.253.338a.65.65 0 0 0 .1.893.65.65 0 0 1 .099.894l-.253.338M13.52 1l-.253.338a.65.65 0 0 0 .1.893.65.65 0 0 1 .1.894l-.254.338m-2.409 3.141-.004-.937h2.333v3.266"
    />
  </svg>
)
export default house_2
